import { NavLink, Link } from "react-router-dom";
import logo from '../assets/images/cc.png';
import {
  Mail,
  Phone,
  Globe,
  MapPin,
  ArrowUpRight,
  Heart,
  Twitter,
  Linkedin,
  Youtube,
  Facebook,
  Instagram,
} from "lucide-react";

const footerLinks = [
  {
    title: "Company",
    links: [
      { label: "Home", to: "/" },
      { label: "About", to: "/about" },
      { label: "Services", to: "/services" },
      { label: "Projects", to: "/projects" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "News & Articles", to: "/news" },
      { label: "Contact", to: "/contact" },
      { label: "Privacy Policy", to: "/" },
      { label: "Terms of Service", to: "/" },
    ],
  },
  {
    title: "AI Services",
    links: [
      { label: "AI Chatbot", to: "/services" },
      { label: "Machine Learning", to: "/services" },
      { label: "NLP Solutions", to: "/services" },
      { label: "Generative AI", to: "/services" },
    ],
  },
];

const FooterNew = () => {

  return (
    <footer className="relative overflow-hidden border-t border-white/[0.04]">
      {/* Background glows */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[900px] h-[400px] rounded-full opacity-[0.04] blur-[120px] pointer-events-none"
        style={{ background: "radial-gradient(ellipse, #7C4DFF, transparent)" }}
      />
      <div
        className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full opacity-[0.03] blur-[80px] pointer-events-none"
        style={{ background: "radial-gradient(circle, #27B8FF, transparent)" }}
      />

      {/* Main footer */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-12 pb-6 sm:pb-8">
        <div className="grid lg:grid-cols-5 gap-8 sm:gap-10 mb-8 sm:mb-10">
          {/* Brand column */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3 no-underline mb-6 group">
              <div className="relative">
                <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-accent via-accent-light to-ai-glow flex items-center justify-center shadow-lg">
                  <img src={logo} alt="ClientCodeAI Logo" />
                </div>
                <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-accent to-ai-glow blur-xl opacity-40 group-hover:opacity-60 transition-opacity duration-500" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold text-white tracking-wide leading-tight">
                  CLIENTCODE AI
                </span>
                <span className="text-[8.5px] font-semibold tracking-[0.14em] text-[#27B8FF] uppercase whitespace-nowrap self-end pl-2">
                  TECHNOLOGY THAT WORK
                </span>
              </div>
            </Link>
            {/* <p className="text-slate-400 text-[0.925rem] leading-relaxed mb-7 max-w-sm">
              Transforming businesses with intelligent AI solutions. Pioneering
              Generative AI, Machine Learning, and NLP technologies for
              enterprise success.
            </p> */}
            <div className="space-y-3.5">
              {[
                { icon: Mail, text: "info@clientcodeai.in" },
                { icon: Phone, text: "+91-9958821387" },
                { icon: Globe, text: "www.clientcodeai.com" },
                { icon: MapPin, text: "Faridabad, Haryana, India" },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3 text-sm text-slate-400 group/item">
                  <div className="p-1.5 rounded-lg transition-all duration-300" style={{
                    background: "rgba(124, 77, 255, 0.06)",
                    border: "1px solid rgba(124, 77, 255, 0.08)",
                  }}>
                    <item.icon className="w-3.5 h-3.5 text-accent-light" />
                  </div>
                  <span className="group-hover/item:text-slate-300 transition-colors">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {footerLinks.map((group, i) => (
            <div key={i}>
              <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
                {group.title}
              </h4>
              <ul className="space-y-3.5 list-none p-0">
                {group.links.map((link, j) => (
                  <li key={j}>
                    <NavLink
                      to={link.to}
                      className="text-slate-400 hover:text-ai-glow text-sm transition-all duration-300 no-underline flex items-center gap-1.5 group/link"
                    >
                      {link.label}
                      <ArrowUpRight className="w-3 h-3 opacity-0 -translate-y-1 group-hover/link:opacity-100 group-hover/link:translate-y-0 transition-all duration-300" />
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/[0.04] pt-7 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            &copy; 2025 CLIENTCODE AI Innovation Pvt. Ltd. All
            Rights Reserved.
          </p>
          {/* Social Icons */}
          <div className="flex items-center gap-3">
            {[
              { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61592497987584", label: "Facebook" },
              { icon: Instagram, href: "https://www.instagram.com/clientcodeai", label: "Instagram" },
              { icon: Linkedin, href: "https://www.linkedin.com/company/clientcode-ai-innovation-private-limited/posts/?feedView=all", label: "LinkedIn" },
              { icon: Twitter, href: "https://x.com/AiClientcode", label: "Twitter" },
              { icon: Youtube, href: "https://www.youtube.com/@clientcodeai", label: "YouTube" },
            ].map((item, i) => (
              <a
                key={i}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={item.label}
                className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 border border-white/10 text-slate-400 transition-all duration-300 hover:text-[#27B8FF] hover:border-[#27B8FF]/40 hover:bg-[#27B8FF]/5"
              >
                <item.icon className="w-4 h-4" />
              </a>
            ))}
          </div>
          <p className="text-slate-500 text-xs flex items-center gap-1.5">
            Built with <Heart className="w-3 h-3 text-accent inline" style={{ filter: "drop-shadow(0 0 4px rgba(124, 77, 255, 0.5))" }} /> and AI
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterNew;
